import React from 'react';
import { navLinks } from '../data/company';
export function SiteNav() {
  return <header className="sticky top-0 z-[60] border-b border-line bg-ink/95 backdrop-blur-md" data-id="element-143" data-mp="3fe94vvy623uc">
      <div className="mx-auto flex max-w-[1080px] items-center gap-4 px-[22px] py-[13px]" data-id="element-144" data-mp="3amzg0xkfz4ji">
        <a href="#top" className="flex shrink-0 items-center gap-2.5 text-[15px] font-extrabold tracking-[-0.02em] text-fg" data-id="element-145" data-mp="35o625418tbit">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-accent text-[13px] font-extrabold text-white" aria-hidden="true" data-id="element-146" data-mp="31mukbkom1ul6">
            MF
          </span>
          <span className="hidden sm:inline" data-id="element-147" data-mp="2roestglo8jb5">Massive Faith LLC</span>
        </a>
        <nav aria-label="Secciones" className="ml-auto flex min-w-0 items-center gap-4" data-id="element-148" data-mp="2rqhg3svfvyc6">
          <div className="flex min-w-0 items-center gap-4 overflow-x-auto text-[13.5px] [scrollbar-width:none]" data-id="element-149" data-mp="2mr4sh5wqun8j">
            {navLinks.map(link => <a key={link.href} href={link.href} className="hidden whitespace-nowrap font-medium text-muted transition-colors duration-150 hover:text-fg lg:inline" data-id="element-150" data-mp="kxf8qckbel3n">
                {link.label}
              </a>)}
          </div>
          <a href="#soporte" className="shrink-0 whitespace-nowrap rounded-lg bg-accent px-3.5 py-2 text-[13.5px] font-bold text-white transition-[filter] duration-150 hover:brightness-110" data-id="element-151" data-mp="3v7lx9ucjntz8">
            Contactar soporte
          </a>
        </nav>
      </div>
      <nav aria-label="Secciones (móvil)" className="border-t border-line lg:hidden" data-id="element-152" data-mp="wpgaq37zvlza">
        <div className="mx-auto flex max-w-[1080px] gap-4 overflow-x-auto px-[22px] py-2.5 text-[12.5px] [scrollbar-width:none]" data-id="element-153" data-mp="i0k8imsmd36l">
          {navLinks.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap font-medium text-muted hover:text-fg" data-id="element-154" data-mp="mxanf6sotsqf">
              {link.label}
            </a>)}
        </div>
      </nav>
    </header>;
}